import React from 'react';
import { useLocation } from 'react-router';

import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { getRouteMetaDataFromPathName } from '../../router/routes.config';

import Title from '../../modules/title/components/title.component';
import SetupStepper from '../../modules/studiotel/components/setup/stepper.component';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      display: 'flex',
      flexDirection: 'column',
      minHeight: '100%',
      background: theme.workflow.background.main,
    },
  })
);

export default function StudiotelSetup() {
  const location = useLocation();

  const routeMeta = getRouteMetaDataFromPathName(location.pathname);
  const classes = useStyles();

  return (
    <div id="studiotel-setup-view" className={classes.container}>
      <Title>{routeMeta && routeMeta.name}</Title>
      <SetupStepper />
    </div>
  );
}
